import { useRef } from "react";

type Validator = (value: any, ...args: any[]) => Promise<string | void>;

export const useApiValidation = (validator: Validator): Validator => {
  // Formik & yup fires validation for every form change, even if only other fields are changed
  // We need to add some caching mechanism to prevent redundant api calls
  const cachedValidator = (asyncValidate: Validator) => {
    let cachedIsValid: string | void = undefined;
    let cachedValue = "";

    return async (value: any, ...rest: any[]) => {
      if (!value || value !== cachedValue) {
        const validationResult = await asyncValidate(value, ...rest);
        cachedValue = value;
        cachedIsValid = validationResult;
        return validationResult;
      }
      return cachedIsValid;
    };
  };

  return useRef(cachedValidator(validator)).current;
};
